/**
* 题库一览
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>题库一览</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="searchForm" class="user-search">
      <el-form-item label="题库名称">
        <el-input size="small" v-model="searchForm.name" placeholder="输入题库名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div>
      <vxe-table border max-height="950"
                 show-overflow :data="listData" v-loading="loading" element-loading-text="拼命加载中">
        <vxe-column field="name" title="名称"></vxe-column>
        <vxe-column field="remarks" title="备注" width="300"></vxe-column>
        <vxe-column title="状态" width="300">
          <template v-slot:default="scope">
            <el-switch
              active-text="禁用"
              inactive-text="启用" @change="handleStatus(scope.row)">
            </el-switch>
          </template>
        </vxe-column>
        <vxe-column title="修改时间" width="300">
          <template v-slot:default="scope">
            <div>{{ scope.row.updateTime|timestampToTime }}</div>
          </template>
        </vxe-column>
        <vxe-column title="操作" show-overflow>
          <template v-slot:default="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="名称" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input size="small" v-model="editForm.remarks" auto-complete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {questionBankDelete, questionBankList, questionBankSave} from '../../api/api'

export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: { // todo
        name: '',
        remarks: ''
      },
      // rules表单验证
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ]
      },
      searchForm: {
        name: '',
        token: localStorage.getItem('logintoken')
      },
      // 一览数据
      listData: []
    }
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getData(this.searchForm)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取题库列表
    getData(parameter) {

      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      questionBankList(parameter)
        .then(res => {
          this.loading = false
          this.listData = res.data
        })
        .catch(err => {
          this.loading = false
          this.$message.error('查询失败！')
        })
    },
    // 搜索事件
    search() {
      this.getData(this.searchForm)
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.name = row.name
        this.editForm.remarks = row.remarks
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.name = ''
        this.editForm.remarks = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          questionBankSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code === 200) {
                this.getData(this.searchForm)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除题目
    handleDelete(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        questionBankDelete(row.id)
          .then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '题库已删除!'
              })
              this.getData(this.searchForm)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 删除，启用题库状态
    handleStatus(index, row) {
      // todo
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/questions/QuestionBank.vue